<template>
  <div id="navigation">

    <header class="navbar">
      <section class="navbar-section">
        <!-- left -->
        <router-link to="/resources">
          <a href="#" class="btn btn-link">Resources</a>
        </router-link>
      </section>
      <section class="navbar-center">
        <!-- centered logo or brand -->
          <router-link to="/">
            <img :src="`/img/logo.png`">
          </router-link>
      </section>
      <section class="navbar-section">
        <router-link to="/about">
          <a href="#" class="btn btn-link">About</a>
        </router-link>
      </section>
    </header>
    <br>
  </div>
</template>

<script>
export default {
  name: 'Navigation',
};
</script>
